import dropdownButton from './dropdown-btn.vue'

dropdownButton.install = function(Vue) {
  Vue.component(dropdownButton.name, dropdownButton)
}

export default dropdownButton
